/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock font-semibold cursor-pointer" v-for="(control, index) in controls" :key="control + index">
                {{ control }}
              </h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="pt-0">
              <div class="vx-row mb-4">
                <div class="vx-col w-7/12 flex items-center">
                  <font-awesome-icon icon="fa-solid fa-mobile-screen" class="h-10 w-10 ml-2 mr-4 text-primary" />
                  <h2 class="font-bold">Risk Finding</h2>
                </div>
                <div class="vx-col w-5/12 flex items-center">
                  <font-awesome-icon icon="fa-solid fa-server" class="h-10 w-10 mr-4 text-primary" />
                  <h2 class="font-bold">Control to Implement</h2>
                </div>
              </div>
              <div class="vx-row items-center border-white rounded p-2">
                <div class="vx-col w-7/12">
                  <h4>Unauthorized software was discovered on technician workstations.</h4>
                </div>
                <div class="vx-col w-5/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer0">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-7/12">
                  <h4>Sensitive materials were found on a fax machine in a common area.</h4>
                </div>
                <div class="vx-col w-5/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer1">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-7/12">
                  <h4>PHI data was found within the development and test environments.</h4>
                </div>
                <div class="vx-col w-5/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer2">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-7/12">
                  <h4>The internet-facing web server allows access to internal data without requiring credentials.</h4>
                </div>
                <div class="vx-col w-5/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer3">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-7/12">
                  <h4>A large number of potentially malicious emails is reaching end-user and shared mailboxes.</h4>
                </div>
                <div class="vx-col w-5/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer4">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-7/12">
                  <h4>A large volume of ICMP traffic is being sent from an external source to Server2.</h4>
                </div>
                <div class="vx-col w-5/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer5">
                  </vue-draggable-container>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';
import shuffle from 'shuffle-array';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      correctAnswers: [
        'Implement MDM solutions',
        'Implement PIN to print',
        'Require data deidentification',
        'Require user authentication',
        'Implement SPF',
        'Filter echo request replies',
      ],

      controls: [
        'Implement file integrity monitoring',
        'Implement PIN to print',
        'Filter echo request replies',
        'Implement MDM solutions',
        'Implement SPF',
        'Require data deidentification',
        'Implement IDS/IPS',
        'Implement web content filter',
        'Implement email encryption',
        'Require user authentication',
      ],

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    /*  drag_error () {
        const now = new Date().getTime()
        if (this.last_drag_error === false || (now - this.last_drag_error) > 7500) {
          this.last_drag_error = now
          this.$vs.notify(
            {
              color: 'warning',
              title: 'Maximum One Answer Per Input',
              position: 'top-center',
              icon: 'feather',
              iconPack: 'icon-alert-circle',
            })
        }
      }, */
    markSimulation() {
      let totalScore = 0;

      for (let i = 0; i < this.correctAnswers.length; i++) {
        const inputServer = document.getElementById(`inputServer${i}`);

        if (inputServer) {
          const answer = inputServer.textContent.trim();
          if (answer === this.correctAnswers[i]) {
            totalScore++;
            inputServer.style.borderColor = '#28C76F';
            inputServer.style.backgroundColor = '#28C76F';
          } else {
            inputServer.style.borderColor = '#c93738';
            inputServer.style.backgroundColor = '#c93738';
          }
        }
      }

      this.$emit('simulation_update_score', totalScore);

      if (totalScore === this.correctAnswers.length) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
    shuffle,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.controls = shuffle(this.controls);
  },
};
</script>

<style scoped>
#wordBank {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0.6rem;
  min-height: unset !important;
}
</style>
